import { render, staticRenderFns } from "./TaskSelectorPanel.vue?vue&type=template&id=f356389a&scoped=true&"
import script from "./TaskSelectorPanel.vue?vue&type=script&lang=js&"
export * from "./TaskSelectorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f356389a",
  null
  
)

export default component.exports